var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:arrow-down-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.82,
    d: "M1.36613 1.45793C1.42675 1.39732 1.50895 1.36328 1.59467 1.36328C1.68038 1.36328 1.76259 1.39732 1.82321 1.45793L3.4233 3.05802L5.0234 1.45793C5.08436 1.39904 5.16602 1.36646 5.25077 1.3672C5.33553 1.36793 5.41661 1.40193 5.47654 1.46186C5.53647 1.5218 5.57047 1.60287 5.5712 1.68763C5.57194 1.77238 5.53936 1.85404 5.48048 1.915L3.65184 3.74364C3.59122 3.80424 3.50902 3.83828 3.4233 3.83828C3.33759 3.83828 3.25538 3.80424 3.19476 3.74364L1.36613 1.915C1.30553 1.85438 1.27148 1.77218 1.27148 1.68646C1.27148 1.60075 1.30553 1.51854 1.36613 1.45793Z",
    fill: "#828181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropDown);
export default __webpack_public_path__ + "static/media/MenuDropDown.f701e5e6bde00339bceb4ba1139a9201.svg";
export { ForwardRef as ReactComponent };